module.exports = "https://la-static.prod-my.games/minigames/collection/img/back.296fa56b.png";